<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Objektų asmenys') }}</h1>
    <!-- search -->
    <!-- <service-limitation-search :loading="loading" @search="searchItems" /> -->
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action :item="item" @editItem="editItem(item)" />
        </div>
      </template>
      <template #[`item.object_type`]="{ item }">
        <el-table-enum enumName="objectType" :item="item.object_type.toString()" />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
// import ServiceLimitationSearch from './ListLimitationSearch'
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'ObjectPersonRules',
  mixins: [userRole, tableParameters],
  components: {
    // ServiceLimitationSearch,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '1rem'
        },
        {
          text: this.$t('Objektas'),
          align: 'start',
          value: 'object_type',
        },
        {
          text: this.$t('Rolė objekte'),
          align: 'start',
          value: 'role_in_object',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.setSortParams()

      const data = {
        ...this.pagination,
        type: 'list',
      }
      this.$axios
        .post(`object-person-rules/list`, data)
        .then((res) => {
          this.listData = res.data.objectPersonRules
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },

    editItem(item) {
      this.$router.push({
        name: 'objectPersonRuleForm',
        params: {
          id: item.id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
